import {
  globalPostService,
  globalGetService,
  globalPutService,
  globalDeleteService,
} from '../../../utils/globalApiServices';

export function getResellerListApi(query = {}) {
  return globalGetService(`csp/reseller`, query).then((response) =>
    response?.ok ? response.data : null
  );
}

export function deleteResellerApi(resellerUid) {
  return globalDeleteService(`csp/reseller/${resellerUid}`);
}
export function addNewResellerApi(data) {
  return globalPostService(`csp/reseller`, data);
}
export function updateResellerApi(resellerUid, formData) {
  return globalPutService(`csp/reseller/${resellerUid}`, formData);
}
